import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, " Здесь Вы можете сообщать нам ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " о свободных машинах, которым нужна ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " загрузка, а наши менеджеры подберут ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, " подходящую под них заявку ", -1)
const _hoisted_5 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_ui_tooltip = _resolveComponent("ui-tooltip")!
  const _component_ui_tooltip_wrapper = _resolveComponent("ui-tooltip-wrapper")!

  return (_openBlock(), _createBlock(_component_ui_tooltip_wrapper, {
    key: $options.triggerTooltip.length,
    placement: "right-start",
    "to-selector": "#truck-offering-link",
    trigger: $options.triggerTooltip,
    visible: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ui_tooltip, {
        class: _normalizeClass(_ctx.$style.wrapper)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.container)
          }, _hoisted_5, 2),
          _createVNode(_component_svg_icon, {
            name: "close",
            class: _normalizeClass(_ctx.$style.closeIcon)
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }, 8, ["trigger"]))
}